/**
 * 홈 도메인 쿼리 키 팩토리
 *
 * 'use client' 없음 — 서버/클라이언트 모두에서 import 가능
 */

import { createQueryKeys } from "@/shared/api/query-keys";

export const homeKeys = createQueryKeys("home");
